import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::index
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:12
* @route '/app/agents/{agent}/behavior'
*/
export const index = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/app/agents/{agent}/behavior',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::index
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:12
* @route '/app/agents/{agent}/behavior'
*/
index.url = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { agent: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { agent: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            agent: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
    }

    return index.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::index
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:12
* @route '/app/agents/{agent}/behavior'
*/
index.get = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::index
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:12
* @route '/app/agents/{agent}/behavior'
*/
index.head = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::index
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:12
* @route '/app/agents/{agent}/behavior'
*/
const indexForm = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::index
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:12
* @route '/app/agents/{agent}/behavior'
*/
indexForm.get = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::index
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:12
* @route '/app/agents/{agent}/behavior'
*/
indexForm.head = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::store
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:22
* @route '/app/agents/{agent}/behavior'
*/
export const store = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/agents/{agent}/behavior',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::store
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:22
* @route '/app/agents/{agent}/behavior'
*/
store.url = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { agent: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { agent: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            agent: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        agent: typeof args.agent === 'object'
        ? args.agent.id
        : args.agent,
    }

    return store.definition.url
            .replace('{agent}', parsedArgs.agent.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::store
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:22
* @route '/app/agents/{agent}/behavior'
*/
store.post = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::store
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:22
* @route '/app/agents/{agent}/behavior'
*/
const storeForm = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\BehaviorRuleController::store
* @see app/Http/Controllers/Admin/BehaviorRuleController.php:22
* @route '/app/agents/{agent}/behavior'
*/
storeForm.post = (args: { agent: string | { id: string } } | [agent: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

const behavior = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
}

export default behavior